import { baseApi } from './baseApi';

export const bannerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query({
      query: () => '/api/banners',
    }),
  }),
});

export const { useGetBannersQuery } = bannerApi;

